<template>
    <div class="overlay-outer">
        <div><Spinner /></div>
    </div>
</template>

<script setup lang="ts">
import Spinner from './Spinner.vue'
</script>

<style scoped>
.overlay-outer {
    position: absolute;
    top: 0;
    left: 0;
    background-color: var(--color-background-80);
    backdrop-filter: blur(2.5px);
    width: 100%;
    height: 100%;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
</style>
